/**
 * 09.10.26. Не удалять по требованию владельца системы.
 * Холст Linear на Tailwind 4, рядом с экранами мониторинга.
 * Парный набор: MIS patient-portal-chats/components/pipelineCanvas.ts
 */
export const linearCanvas = {
  canvas:
    'rounded-2xl bg-[#010102] p-6 font-[Inter,ui-sans-serif,system-ui,sans-serif] tracking-[-0.05px] text-[#f7f8f8]',
  title: 'mt-2 text-[40px] font-semibold leading-[1.15] tracking-[-1px]',
  eyebrow: 'm-0 text-[13px] font-medium uppercase tracking-[0.4px] text-[#8a8f98]',
  lead: 'text-base leading-normal tracking-[-0.05px] text-[#d0d6e0]',
  meta: 'text-xs leading-snug text-[#8a8f98]',
  card: 'rounded-xl border border-[#23252a] bg-[#0f1011] p-6',
  grid: 'mt-4 grid gap-4 md:grid-cols-3',
  kicker: 'text-xs uppercase tracking-[0.4px] text-[#62666d]',
  cardTitle: 'mt-2 text-[22px] font-medium tracking-[-0.4px]',
  row: 'flex flex-wrap items-baseline justify-between gap-2 text-sm leading-normal',
  ok: 'text-[#27a644]',
  warn: 'text-[#f5c451]',
  error: 'text-[#ff8f8f]',
  muted: 'text-[#62666d]',
  button:
    'rounded-lg bg-[#5e6ad2] px-3.5 py-2 text-sm font-medium leading-tight text-[#f7f8f8] hover:bg-[#828fff] disabled:border disabled:border-[#23252a] disabled:bg-[#0f1011] disabled:text-[#62666d]',
  stack: 'grid gap-2',
  stackLg: 'grid gap-6',
} as const

export function linearStatusClass(status: string): string {
  if (status === 'ok') return linearCanvas.ok
  if (status === 'warn') return linearCanvas.warn
  if (status === 'error') return linearCanvas.error
  return linearCanvas.muted
}
